export class DisplayItem {

  constructor(
    public artIdTo?: string,
    public descriptionShort?: string,
    public quantityMinNumber?: number,
    public displayCount?: number,
    public disposable: boolean = false,
    public purchasePrice?: number,
    public salesPrice?: number,
    public order?: number
  ) {

  }
}
